import React from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { MAX_DROPDOWN_HEIGHT } from "../../types/micellinous-constants";

function MomentFilter({ selectedMoment, setSelectedMoment }) {
  const handleMomentChange = (event) => {
    setSelectedMoment(event.target.value);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="Moment-select-label">Moment</InputLabel>
      <Select
        labelId="Moment-select-label"
        id="Moment-select"
        value={selectedMoment}
        onChange={handleMomentChange}
        MenuProps={{
          style: {
            maxHeight: MAX_DROPDOWN_HEIGHT,
          },
        }}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="BEF-PAT/ENV">1. BEF-PAT/ENV</MenuItem>
        <MenuItem value="BEF-ASP">2. BEF-ASP</MenuItem>
        <MenuItem value="AFT-BFL">3. AFT-BFL</MenuItem>
        <MenuItem value="AFT-PAT/ENV">4. AFT-PAT/ENV</MenuItem>
        <MenuItem value="BEF Nurse Med Pass">5. BEF Nurse Med Pass</MenuItem>
        <MenuItem value="AFT Nurse Med Pass">6. AFT Nurse Med Pass</MenuItem>
        <MenuItem value="BEF Resident Meal-time">
          7. BEF Resident Meal-time
        </MenuItem>
        <MenuItem value="Resident Nourishment Pass">
          8. Resident Nourishment Pass
        </MenuItem>
        <MenuItem value="General">9. General</MenuItem>
      </Select>
    </FormControl>
  );
}

export default MomentFilter;
